import { Menu, Transition } from '@headlessui/react'
import {
  KeyIcon,
  LogoutIcon,
  UserCircleIcon,
  UserIcon,
} from '@heroicons/react/outline';
import { Link, useNavigate } from 'react-router-dom'
import { useGetIdentity, useLogout, useTranslation } from '@refinedev/core'
import { IUserData } from 'interfaces';
import { useEffect, useState } from 'react';

export const CurrentUser = () => {
  const { mutate: logout } = useLogout();
  const { data: identity } = useGetIdentity<IUserData>();
  const { translate } = useTranslation();
  const [type, setType] = useState("admin");
  const navigate = useNavigate();

  useEffect(() => {
    const user = localStorage.getItem('USER');

    if (user) {
      const userData = JSON.parse(user);
      setType(userData.type || "admin");
    }
  }, []);

  const getChangePasswordRedirect = () => {
    if (type === "admin") navigate("/change-password");
    if (type === "wps") navigate("/profile/change-password");
  }

  const displayEmail = identity?.email || identity?.name || "Account";
  const menuItemClassName = `
    flex
    items-center
    rounded-md
    px-3
    py-2
    text-sm
    text-gray-700
    hover:bg-gray-50
    cursor-pointer
  `;

  return (
    <Menu as="div" className="relative">
      <Menu.Button className="flex h-10 items-center rounded-full p-1 transition-colors hover:bg-gray-50">
        <span className="sr-only">Open profile dropdown</span>
        {identity?.avatar ? (
          <img
            src={identity.avatar}
            className="size-8 rounded-full object-cover"
            alt="Avatar"
          />
        ) : (
          <span className="flex size-8 items-center justify-center rounded-full bg-gray-100 text-gray-500">
            <UserCircleIcon className="size-6" aria-hidden="true" />
          </span>
        )}
      </Menu.Button>

      <Transition
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          className="
            absolute 
            flex flex-col
            gap-y-1
            right-0 z-10 
            mt-2.5 
            w-60
            rounded-lg
            bg-white 
            p-2
            shadow-lg 
            ring-1 ring-black/5 
            focus:outline-none
            origin-top-right 
          "
        >
          <div className="truncate border-b border-gray-100 px-3 py-3 text-sm font-semibold text-gray-900">
            {displayEmail}
          </div>
          {
            (type && type === 'wps') &&
            <Menu.Item>
              <Link
                to={"/profile"}
                className={menuItemClassName}
              >
                <UserIcon className="w-3.5 mr-2" aria-hidden="true" />
                {translate("my-profile")}
              </Link>
            </Menu.Item>
          }

          <Menu.Item>
            {/* <Link
              to={"/change-password"}
              className="
                flex
                items-center
                py-2 px-3
                text-sm
                hover:bg-gray-50 
                cursor-pointer
                round-sm
              "
            >
              <KeyIcon className="w-3.5 mr-2" aria-hidden="true" />
              {translate("change-password")}
            </Link> */}
            <div className={menuItemClassName} onClick={getChangePasswordRedirect}>
              <KeyIcon className="w-3.5 mr-2" aria-hidden="true" />
              {translate("change-password")}
            </div>
          </Menu.Item>
          <Menu.Item>
            <div
              onClick={() => logout()}
              className={menuItemClassName}
            >
              <LogoutIcon className="w-3.5 mr-2" aria-hidden="true" />
              {translate("sign-out")}
            </div>
          </Menu.Item>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}
